module.exports = __webpack_public_path__ + "static/media/value-card-icon.f77ba5b7.svg";